<template>
  <div>
    <snackbarcomp
      v-bind:mesaj="text1"
      v-model="snackbar"
      v-bind:color="snackbarkColor"
    ></snackbarcomp>
    <span class="caption text--gray">{{ name }}</span>
    <span
      v-if="description != null"
      class="caption text--gray"
      style="float: right"
      ><strong>( {{ description }} )</strong></span
    >
    <v-text-field
      v-model="valueInput"
      class="centered-input text--darken-3 mt-0"
      type="number"
      min="0"
      solo
    >
      <template v-slot:append>
        <v-icon :color="'info'" @click="remove()"> person_remove_alt_1 </v-icon>
      </template>

      <template v-slot:prepend-inner>
        <v-icon :color="'info'" @click="add()"> person_add </v-icon>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    value: {
      type: Number,
      default: 0,
    },
    totalValue: {
      type: Number,
    },
  },
  computed: {
    valueInput: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      snackbar: false,
      text1: null,
      snackbarkColor: null,
    };
  },
  methods: {
    add() {
      if (this.totalValue >= 7) {
        this.snackbar = true;
        this.text1 = this.$t('Maximum-number-passengers-cannot-exceed');
        this.snackbarkColor = "warning";
      } else if (this.valueInput != 7) {
        this.valueInput = Number(this.valueInput) + 1;
        this.$emit("passengerValue", 1);
      }
    },
    remove() {
      if (this.valueInput != 0) {
        this.valueInput = Number(this.valueInput) - 1;
        this.$emit("passengerValue", -1);
      }
    },
  },
  components: {
    snackbarcomp,
  },
};
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
.centered-label {
  text-align: center;
}
</style>